export default __webpack_public_path__ + "static/media/coffe.57e41414.svg";